var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header"},[_c('div',{staticClass:"left"},[_vm._v(_vm._s(_vm.title))]),(!!_vm.linkto)?_c('router-link',{staticClass:"right",attrs:{"target":"_blank","to":_vm.linkto}},[_vm._v("MORE "),_c('span')]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }